import { SubCategory } from '@quorum/models/xs-resource';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { svcDropdownsFeatureSelector } from '../svc-dropdowns-feature.selector';
export interface VehicleSubcategoriesState extends EntityState<SubCategory> {}

export const vehicleSubcategoriesAdapter: EntityAdapter<SubCategory> = createEntityAdapter<SubCategory>({
  selectId: (subcategory: SubCategory) => subcategory.id
});

export const initialState: VehicleSubcategoriesState = vehicleSubcategoriesAdapter.getInitialState({ loading: true });
export const vehicleSubcategoriesSelector = createSelector(
  svcDropdownsFeatureSelector,
  (state: any) => state.vehicleSubcategories
);

export const { selectIds, selectEntities, selectAll, selectTotal } = vehicleSubcategoriesAdapter.getSelectors(
  vehicleSubcategoriesSelector
);
